import { CSSProperties, memo, PropsWithChildren } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MoveIcon, Preloader } from '@smartshell/ui-kit';
import classNames from 'classnames';

import { useWindowResize } from 'hooks';

import { IProps } from './interfaces';
import s from './SortableItem.module.scss';

export const SortableItem = memo<PropsWithChildren<IProps>>(
  ({ id, children, loading }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
      setActivatorNodeRef,
    } = useSortable({
      id,
      disabled: loading,
    });

    const size = useWindowResize();
    return (
      <div
        ref={size.width > 960 ? setNodeRef : undefined}
        className={classNames(s.item, isDragging && s.dragging)}
        style={
          {
            transform:
              transform &&
              CSS.Transform.toString({ ...transform, scaleY: 1, scaleX: 1 }),
            transition,
          } as CSSProperties
        }
        {...attributes}
      >
        {size.width > 960 && (
          <button
            ref={setActivatorNodeRef}
            {...listeners}
            className={s.handler}
            disabled={loading}
          >
            <Preloader loading={loading} small>
              <MoveIcon size="s" />
            </Preloader>
          </button>
        )}
        {children}
      </div>
    );
  }
);
